import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import WeatherMap from "../components/WeatherMap";
import WeatherStations from "../components/WeatherStations";
import { fetchWeather } from "../store/weather";

const StackPayesh = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = () => {
      dispatch(fetchWeather());
    };

    fetchData();

    const intervalId = setInterval(fetchData, 900000); // 900000 ms = 15 minutes

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, [dispatch]);

  return (
    <div>
      <WeatherMap />
      <WeatherStations />
    </div>
  );
};

export default StackPayesh;
